import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaStar, FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp,
  FaClock, FaOm, FaPaperPlane, FaFacebook, FaLinkedin, FaGoogle,
  FaCalendarCheck, FaClipboardList, FaUserClock
} from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', subject: '', message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: process.env.REACT_APP_WEB3FORMS_ACCESS_KEY,
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          subject: formData.subject ? `Consultation Request: ${formData.subject}` : 'Consultation Request',
          message: formData.message,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        setTimeout(() => setSubmitted(false), 5000);
      } else {
        setError('Something went wrong. Please try again or contact us directly.');
      }
    } catch (err) {
      setError('Unable to send message. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Hero */}
      <section className="page-hero">
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(40)].map((_, i) => (
            <div key={i} className="page-hero-star" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              width: `${Math.random() * 3 + 1}px`,
              height: `${Math.random() * 3 + 1}px`,
            }} />
          ))}
        </div>
        <div className="page-hero-content">
          <div className="hero-badge-sm"><FaStar /> Get In Touch</div>
          <h1>Contact Us</h1>
          <p>Reach out for personalized astrological consultation and cosmic guidance</p>
          <div className="breadcrumb"><Link to="/">Home</Link> <span>/</span> <span>Contact Us</span></div>
        </div>
      </section>

      {/* Contact Main */}
      <section className="py-20 bg-warm-off-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1.3fr] gap-[50px] max-md:gap-10 items-start">
            {/* Contact Info */}
            <div>
              <h2 className="text-[2rem] text-primary-dark mb-2.5 font-heading">Let's Connect</h2>
              <p className="text-warm-gray text-[0.95rem] mb-[30px]">Have questions about your destiny? Want to book a consultation? We're here to guide you on your cosmic journey.</p>

              <div className="flex flex-col gap-[15px]">
                {[
                  { href: 'tel:+918084768303', icon: <FaPhone />, title: 'Call Us', text: '+91 80847 68303' },
                  { href: 'https://wa.me/919835040629', icon: <FaWhatsapp />, title: 'WhatsApp', text: '+91 98350 40629', isWhatsapp: true, external: true },
                  { href: 'mailto:acharyaarunastrology@gmail.com', icon: <FaEnvelope />, title: 'Email Us', text: 'acharyaarunastrology@gmail.com' },
                ].map((item, i) => (
                  <a key={i} href={item.href} {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})} className="info-card flex items-center gap-[15px] py-[18px] px-5 bg-white rounded-[14px] border border-warm-light-gray transition-all duration-400 relative overflow-hidden hover:border-accent-gold/30 hover:translate-x-[5px] hover:shadow-[0_8px_25px_rgba(12,10,32,0.08),0_0_0_1px_rgba(167,139,250,0.1)]">
                    <div className={`w-[50px] h-[50px] rounded-full flex items-center justify-center text-[1.2rem] flex-shrink-0 ${item.isWhatsapp ? 'bg-[rgba(37,211,102,0.15)] text-[#25d366]' : 'text-primary-medium'}`} style={!item.isWhatsapp ? { background: 'linear-gradient(135deg, rgba(167,139,250,0.1), rgba(249,115,22,0.1))' } : undefined}>
                      {item.icon}
                    </div>
                    <div>
                      <h4 className="text-[0.9rem] text-primary-dark font-body font-semibold mb-[2px]">{item.title}</h4>
                      <span className="text-[0.85rem] text-warm-gray">{item.text}</span>
                    </div>
                  </a>
                ))}

                {[
                  { icon: <FaMapMarkerAlt />, title: 'Visit Us', text: 'Flat No 402, 4th Floor, Nand Maheshwari Apt, Behind Harihar Chamber, Gorakhnath Lane, Kidwaipuri, Patna-800001, Bihar' },
                  { icon: <FaClock />, title: 'Available Hours', text: 'Mon - Sun: 9:00 AM - 9:00 PM' },
                ].map((item, i) => (
                  <div key={i} className="info-card flex items-center gap-[15px] py-[18px] px-5 bg-white rounded-[14px] border border-warm-light-gray transition-all duration-400 relative overflow-hidden hover:border-accent-gold/30 hover:translate-x-[5px] hover:shadow-[0_8px_25px_rgba(12,10,32,0.08),0_0_0_1px_rgba(167,139,250,0.1)]">
                    <div className="w-[50px] h-[50px] rounded-full flex items-center justify-center text-[1.2rem] flex-shrink-0 text-primary-medium" style={{ background: 'linear-gradient(135deg, rgba(167,139,250,0.1), rgba(249,115,22,0.1))' }}>
                      {item.icon}
                    </div>
                    <div>
                      <h4 className="text-[0.9rem] text-primary-dark font-body font-semibold mb-[2px]">{item.title}</h4>
                      <span className="text-[0.85rem] text-warm-gray">{item.text}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-[30px]">
                <h4 className="text-[0.95rem] text-primary-dark font-body font-semibold mb-3">Follow Us</h4>
                <div className="flex gap-3">
                  {[
                    { href: 'https://share.google/meosnbKBvhMKeJ4uM', icon: <FaGoogle />, label: 'Google' },
                    { href: 'https://www.facebook.com/acharya.arun.1/', icon: <FaFacebook />, label: 'Facebook' },
                    { href: 'https://www.linkedin.com/in/acharya-arun-89b8928a/', icon: <FaLinkedin />, label: 'LinkedIn' },
                    { href: 'https://wa.me/919835040629', icon: <FaWhatsapp />, label: 'WhatsApp' },
                  ].map((s, i) => (
                    <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}
                      className="w-[42px] h-[42px] rounded-full border border-warm-light-gray flex items-center justify-center text-primary-medium text-[1.1rem] transition-all duration-300 hover:bg-gradient-warm hover:text-white hover:border-transparent hover:-translate-y-[3px]">
                      {s.icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-[20px] p-[45px] max-md:p-[30px_20px] border border-warm-light-gray shadow-[0_8px_40px_rgba(12,10,32,0.06)] transition-shadow duration-500 hover:shadow-[0_12px_50px_rgba(12,10,32,0.1),0_0_0_1px_rgba(167,139,250,0.1)]">
              <div className="text-center mb-[30px]">
                <FaOm className="text-[2rem] text-accent-gold mb-2.5 mx-auto" />
                <h2 className="text-[1.5rem] text-primary-dark mb-2 font-heading">Book Your Consultation</h2>
                <p className="text-[0.9rem] text-warm-gray">Fill in your details and we'll get back to you with cosmic guidance</p>
              </div>

              {submitted && (
                <div className="flex items-center gap-2.5 py-[15px] px-5 bg-[rgba(46,204,113,0.1)] border border-[rgba(46,204,113,0.3)] rounded-[10px] text-[#27ae60] text-[0.9rem] mb-[25px]">
                  <FaStar /> Thank you! Your message has been sent. We'll contact you soon with cosmic guidance.
                </div>
              )}

              {error && (
                <div className="flex items-center gap-2.5 py-[15px] px-5 bg-[rgba(231,76,60,0.1)] border border-[rgba(231,76,60,0.3)] rounded-[10px] text-[#c0392b] text-[0.9rem] mb-[25px]">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div className="mb-5">
                    <label htmlFor="name" className="block text-[0.85rem] font-semibold text-primary-dark mb-2">Full Name *</label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required
                      className="w-full py-3 px-4 border border-warm-light-gray rounded-[10px] font-body text-[0.9rem] text-primary-dark bg-warm-off-white transition-all duration-400 focus:outline-none focus:border-accent-gold focus:shadow-[0_0_0_3px_rgba(167,139,250,0.12),0_0_20px_rgba(167,139,250,0.08)] focus:bg-white" />
                  </div>
                  <div className="mb-5">
                    <label htmlFor="email" className="block text-[0.85rem] font-semibold text-primary-dark mb-2">Email Address *</label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required
                      className="w-full py-3 px-4 border border-warm-light-gray rounded-[10px] font-body text-[0.9rem] text-primary-dark bg-warm-off-white transition-all duration-400 focus:outline-none focus:border-accent-gold focus:shadow-[0_0_0_3px_rgba(167,139,250,0.12),0_0_20px_rgba(167,139,250,0.08)] focus:bg-white" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div className="mb-5">
                    <label htmlFor="phone" className="block text-[0.85rem] font-semibold text-primary-dark mb-2">Phone Number *</label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter your phone number" required
                      className="w-full py-3 px-4 border border-warm-light-gray rounded-[10px] font-body text-[0.9rem] text-primary-dark bg-warm-off-white transition-all duration-400 focus:outline-none focus:border-accent-gold focus:shadow-[0_0_0_3px_rgba(167,139,250,0.12),0_0_20px_rgba(167,139,250,0.08)] focus:bg-white" />
                  </div>
                  <div className="mb-5">
                    <label htmlFor="subject" className="block text-[0.85rem] font-semibold text-primary-dark mb-2">Subject</label>
                    <select id="subject" name="subject" value={formData.subject} onChange={handleChange}
                      className="w-full py-3 px-4 border border-warm-light-gray rounded-[10px] font-body text-[0.9rem] text-primary-dark bg-warm-off-white transition-all duration-400 focus:outline-none focus:border-accent-gold focus:shadow-[0_0_0_3px_rgba(167,139,250,0.12),0_0_20px_rgba(167,139,250,0.08)] focus:bg-white">
                      <option value="">Select a service</option>
                      <option value="career">Career Advice</option>
                      <option value="medical">Medical Astrology</option>
                      <option value="gem">Gem Suggestion</option>
                      <option value="marriage">Marriage & Progeny</option>
                      <option value="horoscope">Horoscope Making</option>
                      <option value="matchmaking">Match Making</option>
                      <option value="graha-shanti">Graha Shanti</option>
                      <option value="kp">KP Astrology</option>
                      <option value="muhurta">Muhurta Astrology</option>
                      <option value="vastu">Vastu Consultation</option>
                    </select>
                  </div>
                </div>

                <div className="mb-5">
                  <label htmlFor="message" className="block text-[0.85rem] font-semibold text-primary-dark mb-2">Your Message</label>
                  <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange}
                    placeholder="Describe your concern or share your birth details (Date, Time, Place of birth)..."
                    className="w-full py-3 px-4 border border-warm-light-gray rounded-[10px] font-body text-[0.9rem] text-primary-dark bg-warm-off-white transition-all duration-400 resize-y min-h-[120px] focus:outline-none focus:border-accent-gold focus:shadow-[0_0_0_3px_rgba(167,139,250,0.12),0_0_20px_rgba(167,139,250,0.08)] focus:bg-white" />
                </div>

                <button type="submit" disabled={loading} className="btn-primary w-full justify-center py-4 text-[1.05rem] disabled:opacity-70 disabled:cursor-not-allowed">
                  <FaPaperPlane /> {loading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Preparation Guide */}
      <section className="py-20 md:py-28 bg-warm-off-white">
        <div className="container-custom">
          <div className="section-title">
            <h2>Prepare for Your Consultation</h2>
            <p>Follow these simple steps for the most accurate astrological guidance</p>
            <div className="decorative-line"><span></span><div className="dot"></div><span></span></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
            {[
              { icon: <FaClipboardList />, title: 'Gather Birth Details', desc: 'Have your exact date of birth, time of birth, and place of birth ready. These are essential for accurate chart preparation.' },
              { icon: <FaCalendarCheck />, title: 'Note Your Questions', desc: 'Write down specific questions or concerns you want to discuss — career, health, marriage, finance, or any life events.' },
              { icon: <FaUserClock />, title: 'Be On Time', desc: 'Join 5 minutes before the scheduled time. Keep a quiet environment for focused consultation and better cosmic connection.' },
            ].map((card, i) => (
              <div key={i} className="prep-card group bg-white rounded-[20px] py-10 px-[30px] text-center border border-warm-light-gray transition-all duration-500 relative overflow-hidden hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(12,10,32,0.1),0_0_0_1px_rgba(167,139,250,0.15)] hover:border-accent-gold/30">
                <div className="w-[70px] h-[70px] rounded-full flex items-center justify-center mx-auto mb-5 text-[1.6rem] text-accent-saffron transition-all duration-400 relative z-[1] group-hover:bg-gradient-warm group-hover:text-white" style={{ background: 'linear-gradient(135deg, rgba(167,139,250,0.1), rgba(249,115,22,0.1))' }}>
                  {card.icon}
                </div>
                <h3 className="text-[1.15rem] mb-3 text-primary-dark font-heading">{card.title}</h3>
                <p className="text-[0.9rem] text-warm-gray leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Bottom */}
      <section className="py-[100px] max-md:py-20 bg-gradient-cosmic relative overflow-hidden text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(167,139,250,0.08), transparent 70%)' }} />
        <div className="container-custom relative z-[2]">
          <FaOm className="text-[2.5rem] text-accent-gold mb-4 mx-auto" />
          <h2 className="text-[2rem] max-md:text-[1.5rem] text-white mb-2.5 font-heading">Consultations Available Online & In-Person</h2>
          <p className="text-[1.05rem] text-white/70 max-w-[600px] mx-auto">Connect from anywhere in the world. Phone, WhatsApp, and video consultations available.</p>
          <a href="tel:+918084768303" className="btn-primary mt-6 inline-flex">
            <FaPhone /> Call Now for Immediate Consultation
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;
